// @flow

import React from 'react'
import { createComponent } from 'react-fela'
import PropTypes from 'prop-types'

// components
import SubLoader from 'design-framework/components/SubLoader'
import { slugify } from 'design-framework/utils/helpers'

import { __buttonText, __buttonWrapper } from './__style'

const ButtonWrapper = createComponent(__buttonWrapper, 'div', ['tabIndex'])
const ButtonText = createComponent(__buttonText, 'button', [
	'data-id',
	'data-auto',
	'tabIndex',
	'type',
])

const Button = ({
	disabled,
	onClick,
	children,
	idSelector,
	identifier,
	autokey,
	isLoading,
	loaderText = '',
	type,
	size,
	isFullWidth,
	style,
	className,
	isFloat,
	tabIndex,
	btnType,
	...props
}) => {
	let page = ''
	if (typeof window === 'object' && window?.pagename) page = window?.pagename

	let buttonId =
		identifier ||
		(typeof children === 'string' && children) ||
		idSelector ||
		''
	buttonId = slugify(`${page} ${buttonId} button`)

	return (
		<ButtonWrapper isFullWidth={isFullWidth} {...props}>
			<ButtonText
				style={style}
				className={className}
				id={buttonId}
				data-id={idSelector}
				data-auto={autokey}
				isFullWidth={isFullWidth}
				disabled={!isLoading && disabled}
				onClick={e => {
					if (!isLoading && !disabled) {
						return onClick(e)
					}

					return null
				}}
				passThrough={['onClick']}
				type={btnType}
				btnColor={type}
				size={size}
				isFloat={isFloat}
				tabIndex={tabIndex}
				onKeyPress={e => {
					if (!isLoading && !disabled) {
						return onClick(e)
					}

					return null
				}}
			>
				{!isLoading ? children : <SubLoader loaderText={loaderText} />}
			</ButtonText>
		</ButtonWrapper>
	)
}

Button.propTypes = {
	primary: PropTypes.bool,
	/** Type of the button. Primary/Secondary. Defaults to Primary */
	type: PropTypes.string,
	/** Size of the button (SMALL/LARGE/MEDIUM). Defaults to Medium button */
	size: PropTypes.string,
	/** Status of button. Loading state. Disable onClick in that case.Defaults to false */
	isLoading: PropTypes.bool,
	/** Disabled or not */
	disabled: PropTypes.bool,
	/** Onclick call back function */
	onClick: PropTypes.func,
	/** Style object. Not recommended to use */
	style: PropTypes.object,
	/** Makes large button width 100% */
	isFullWidth: PropTypes.bool,
	/** Makes button float to bottom-right */
	isFloat: PropTypes.bool,
	/** Type attribute of button tag */
	btnType: PropTypes.string,
	/** Used to identify the Button and set it in the 'id' attribute */
	identifier: PropTypes.string,
}

Button.defaultProps = {
	primary: true,
	isLoading: false,
	type: 'PRIMARY',
	size: 'MEDIUM',
	disabled: false,
	isFloat: false,
	identifier: '',
}

export default Button
